import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "49",
  height: "46",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "48",
  height: "12.255",
  x: ".334",
  y: ".872",
  fill: "#528BFF",
  rx: "4"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "48",
  height: "12.255",
  x: ".334",
  y: "16.872",
  fill: "#EAECF0",
  rx: "4"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  width: "48",
  height: "12.255",
  x: ".334",
  y: "32.872",
  fill: "#EAECF0",
  rx: "4"
}, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }